import Icon from 'engage/components/Icon/Icon';
import React from 'react';
import styles from './BrandingAccordionHeader.module.scss';
import cx from 'classnames';

export const BrandingAccordionHeader = ({ isActive, title, description, onClick }) => {
    return <div className={styles.container} role='button' tabIndex={0} onClick={onClick} onKeyDown={onClick}>
        <Icon src="arrowDown" className={cx(styles.arrowIcon, {[styles.active]: isActive})} />
        <div className={styles.titleContainer}>
            <h2 className={styles.title}>
                {title}
            </h2>
            <span>{description}</span>
        </div>
    </div>
}